import { gql } from '@apollo/client'

export const AUTHENTICATE_FORGOT_PASSWORD_MUTATION = gql`
  mutation forgotPassword($email: String!, $deviceInfo: InputUserDeviceInfo ) {
    forgotPassword(input: { email: $email, deviceInfo: $deviceInfo}) {
      success
      message
    }
  }
`

export const AUTHENTICATE_CONFIRM_PASSWORD_MUTATION = gql`
  mutation confirmPassword($email: String!, $newPassword: String!, $token: String!, $tokenUuid: String!) {
    confirmPassword(input: { email: $email, newPassword: $newPassword, token: $token, tokenUuid: $tokenUuid }) {
      success
      message
    }
  }
`

export const AUTHENTICATE_CHANGE_PASSWORD_MUTATION = gql`
  mutation changePassword($id: ID!, $oldPassword: String!, $newPassword: String!) {
    changePassword(input: { id: $id, oldPassword: $oldPassword, newPassword: $newPassword }) {
      success
      message
    }
  }
`

